import React, { useEffect, useState } from 'react'
import GlobalBanner from './GlobalBanner_newUI'
import { isFeatureEnabled } from 'util/featureFlags'

const STORAGE_KEY = 'trainerconnect_banner_dismissals'

const getDismissalIntervalDays = (dismissCount) => {
  if (dismissCount === 0) return 0
  if (dismissCount === 1) return 7
  if (dismissCount === 2) return 14
  return 30
}

const getBannerDismissalData = (bannerId) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return null

    const allDismissals = JSON.parse(stored)
    return allDismissals[bannerId] || null
  } catch (e) {
    console.debug('Error reading banner dismissal data:', e)
    return null
  }
}

const saveBannerDismissal = (bannerId) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    const allDismissals = stored ? JSON.parse(stored) : {}

    const existing = allDismissals[bannerId] || { count: 0 }
    const newCount = existing.count + 1

    allDismissals[bannerId] = {
      count: newCount,
      lastDismissedAt: new Date().toISOString(),
      nextShowAfter: new Date(
        Date.now() + getDismissalIntervalDays(newCount) * 24 * 60 * 60 * 1000
      ).toISOString(),
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(allDismissals))
  } catch (e) {
    console.debug('Error saving banner dismissal:', e)
  }
}

const shouldShowBanner = (bannerId) => {
  const dismissalData = getBannerDismissalData(bannerId)

  if (!dismissalData) return true

  const nextShowAfter = new Date(dismissalData.nextShowAfter)
  const now = new Date()

  return now >= nextShowAfter
}

const GlobalBannerContainer = ({ banners = [] }) => {
  const [visibleBanners, setVisibleBanners] = useState([])

  useEffect(() => {
    const filteredBanners = banners.filter((banner) =>
      shouldShowBanner(banner.id)
    )
    setVisibleBanners(filteredBanners)
  }, [banners])

  const handleCloseBanner = (bannerId) => {
    saveBannerDismissal(bannerId)
    setVisibleBanners((prevBanners) =>
      prevBanners.filter((b) => b.id !== bannerId)
    )
  }

  if (!isFeatureEnabled('NEW_UI')) {
    return null
  }

  if (!visibleBanners || visibleBanners.length === 0) {
    return null
  }

  return (
    <div className="fixed top-[60px] left-0 right-0 z-50 flex flex-col gap-3 px-2 pt-0.5 desktop:pt-4 desktop:px-8 desktop:w-full pointer-events-none">
      {visibleBanners.map((banner, index) => (
        <div key={banner.id || index} className="pointer-events-auto">
          <GlobalBanner
            message={banner.message}
            type={banner.type}
            onClose={
              banner.dismissible !== false
                ? () => handleCloseBanner(banner.id || index)
                : null
            }
          />
        </div>
      ))}
    </div>
  )
}

export default GlobalBannerContainer
